export default {
  fetchDataFailed:
    "Benutzerdaten konnten nicht geladen werden, bitte versuchen Sie es erneut oder wenden Sie sich an den Support",
  password_changed_other_tab: "Passwort in einem anderen Tab aktualisiert",
  profile_updated_other_tab: "Profil in einem anderen Tab aktualisiert",
  report_updated_other_tab: "Die Berichtskonfiguration wurde in einem anderen Tab aktualisiert.",
  logged_out_other_tab: "Sie wurden in einem anderen Tab abgemeldet",
  oauth: {
    processing: "Anmeldeanfrage wird verarbeitet...",
  },
  ticket: {
    modal_title: "Ticket erstellen",
    not_logged_in: "Bitte melden Sie sich zuerst an",
    login_required:
      "Um ein Ticket zu erstellen, müssen Sie in Ihrem Konto angemeldet sein. Möchten Sie zur Anmeldeseite gehen?",
    go_to_login: "Zur Anmeldung gehen",
    submit_success:
      "Ticket erfolgreich eingereicht! Unser Support-Team wird innerhalb von 24-48 Stunden antworten.",
    email: "E-Mail",
    email_placeholder: "Bitte geben Sie Ihre E-Mail-Adresse ein",
    type: "Problemart",
    type_placeholder: "Bitte wählen Sie die Problemart aus",
    subject: "Betreff",
    subject_placeholder: "Bitte geben Sie einen Betreff für Ihr Ticket ein (5-100 Zeichen)",
    description: "Problembeschreibung",
    description_placeholder: "Bitte beschreiben Sie das Problem im Detail",
    submit_ticket: "Ticket absenden",
    submit_failed: "Ticket konnte nicht gesendet werden!",
    email_send_failed_title: "E-Mail-Benachrichtigungsproblem",
    email_send_failed_desc:
      "Ihr Ticket wurde erfolgreich eingereicht, aber wir haben Probleme beim Senden der E-Mail-Benachrichtigung festgestellt. Unser Support-Team wird Ihre Anfrage dennoch bearbeiten.",
  },
};
